import React from 'react';
import {withTranslation} from 'react-i18next';
import {Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Row} from 'reactstrap';
import LoaderButton from '../components/LoaderButton';
import ModalManager from '../components/modal/ModalManager';
import TextField from '../components/TextField';

class KycFeedbackForm extends React.Component {
  updateFeedback = async formValues => {
    const {values, onSubmit} = this.props;
    try {
      await onSubmit({...values, ...formValues});
      ModalManager.close({
        isOpen: false
      });
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  render() {
    const {t, feedback} = this.props;
    return (
      <FinalForm
        onSubmit={this.updateFeedback}
        initialValues={{feedback: feedback ? feedback : undefined}}
        render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
          return (
            <Form>
              <Row>
                <Col>
                  <TextField
                    item={{
                      name: 'feedback',
                      i18n: t('Please inform the user, the reason for the rejection of the submitted document.'),
                      type: 'textarea',
                      required: true,
                      rows: 3,
                    }}
                  />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <LoaderButton
                    color="success"
                    loading={submitting}
                    disabled={pristine || hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}
                    onClick={handleSubmit}>
                    {t('Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(KycFeedbackForm);
